import { JSX } from "react";
import { appContext } from "../../../AppContext";
import { IbssComponent } from "../../../Components/Core/BaseComponent/IbssComponent";
import { Navigate } from "react-router";

export default class RequiresAuth extends IbssComponent<IProps, IState>
{
    private isAuthenticated(): boolean
    {
        let isAuthenticated = true;
        const token = appContext().authentication.getToken()
        if (!token)
        {
            isAuthenticated = false;
        }
        return isAuthenticated;
    }

    private isAuthorised(requiredRights: string[]): boolean
    {
        if (requiredRights.length == 0)
        {
            return true;
        }
        for (const right of requiredRights)
        {
            const hasRight = appContext().localStorageProvider.hasRight(right);
            if (hasRight)
            {
                return true;
            }
        }
        return false;
    }

    public render(): JSX.Element
    {
        const isAuthenticated = this.isAuthenticated();
        const isAuthorised = this.isAuthorised(this.props.requiredRights);

        if (!isAuthenticated)
        {
            appContext().authentication.logOut();
            return (<></>);
        }
        else if (!isAuthorised)
        {
            return (
                <Navigate
                    to={{ pathname: "/norights" }}
                    replace
                />
            );
        }
        else
        {
            return (<>{this.props.children}</>);
        }
    }
}

interface IProps
{
    requiredRights: string[];
    children: React.ReactNode;
}

interface IState { }
